import { Box, Typography, Stack } from '@mui/material';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useTranslation } from 'react-i18next';

export default function ScanImage(props: any) {
    const { item, isPlaceholder } = props;
    const { t } = useTranslation();

    const handleDragStart = (e: any) => e.preventDefault();

    // Shared styles for image containers
    const imageContainerStyles = {
        width: '100%',
        aspectRatio: '16 / 9',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        borderRadius: 2,
        position: 'relative',
    };

    // If this is a placeholder image, render logo + text
    if (isPlaceholder) {
        return (
            <Stack
                sx={{
                    ...imageContainerStyles,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                }}
            >
                <Box
                    component="img"
                    src={item}
                    alt="Spectre Logo"
                    onDragStart={handleDragStart}
                    sx={{
                        maxWidth: '40%',
                        maxHeight: '50%',
                        objectFit: 'contain',
                        mb: 2,
                        borderRadius: '12px'
                    }}
                />
                <Typography
                    variant="h5"
                    sx={{
                        color: 'text.secondary',
                        textAlign: 'center',
                        mt: 1,
                    }}
                >
                    {t('control.centerControl.awaitingScan')}
                </Typography>
            </Stack>
        );
    }

    // Normal image rendering
    return (
        <Box sx={imageContainerStyles}>
            <Box
                component="img"
                src={item}
                alt="Scan image"
                onDragStart={handleDragStart}
                role="presentation"
                sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain', // maintain aspect ratio
                    display: 'block',
                    margin: 'auto',
                    borderRadius: '12px',
                }}
            />
        </Box>
    );
}